export const DEFAULT_FORMATION_CONFIG = {
  numberOfTeams: 2,
  playerPool: 'AVAILABLE_AND_RESERVE',
  minPlayersRequired: 4,
  autoFormEnabled: false,
  autoFormHoursBefore: 24,
  autoPublishTeams: true,
};

export const mapSeriesFormationConfig = (series) => ({
  ...DEFAULT_FORMATION_CONFIG,
  ...(series?.formationConfig || {}),
});

export const buildFormationConfigPayload = (config) => ({
  numberOfTeams: Number(config.numberOfTeams) || 2,
  playerPool: config.playerPool || 'AVAILABLE_ONLY',
  minPlayersRequired: Number(config.minPlayersRequired) || 4,
  autoFormEnabled: Boolean(config.autoFormEnabled),
  autoFormHoursBefore: Number(config.autoFormHoursBefore) || 24,
  autoPublishTeams: config.autoPublishTeams !== false,
});

export const getFormationBadge = (practice) => {
  const settings = practice?.formationSettings;
  if (practice?.teamFormationId) {
    if (settings?.formationAutoFormedAt) {
      return { label: 'Teams auto-formed', className: 'practice-plan-badge practice-plan-badge--ready' };
    }
    if (practice.teamsPublishedToPublic) {
      return { label: 'Teams published', className: 'practice-plan-badge practice-plan-badge--ready' };
    }
    return { label: 'Teams formed', className: 'practice-plan-badge practice-plan-badge--ready' };
  }
  if (settings?.autoFormEnabled && settings.formationScheduledAt) {
    const scheduled = new Date(settings.formationScheduledAt);
    if (scheduled > new Date()) {
      return {
        label: `Teams scheduled ${scheduled.toLocaleString()}`,
        className: 'practice-plan-badge practice-plan-badge--draft',
      };
    }
    const count = settings.rsvpEligibleCount ?? 0;
    const min = settings.minPlayersRequired ?? 4;
    if (count < min) {
      return {
        label: `Waiting for RSVPs (${count}/${min})`,
        className: 'practice-plan-badge practice-plan-badge--pending',
      };
    }
    return { label: 'Ready to auto-form', className: 'practice-plan-badge practice-plan-badge--draft' };
  }
  return null;
};

export const canFormTeamsFromRsvps = (practice) => {
  const settings = practice?.formationSettings;
  if (!settings || practice?.teamFormationId) return false;
  const count = settings.rsvpEligibleCount ?? 0;
  const teams = settings.numberOfTeams ?? 2;
  const min = settings.minPlayersRequired ?? 4;
  return count >= teams && count >= min;
};
